const GAP = 10;

document.querySelectorAll('.agenda__list').forEach((list) => {
    const markers = Array.from(list.querySelectorAll('.agenda__item-marker'));
    if (markers.length < 2) return;

    const render = () => {
        list.querySelectorAll('.agenda__connector').forEach((el) => el.remove());

        const listRect = list.getBoundingClientRect();

        for (let i = 0; i < markers.length - 1; i++) {
            const a = markers[i].getBoundingClientRect();
            const b = markers[i + 1].getBoundingClientRect();

            const top = a.top + a.height / 2 - listRect.top + GAP;
            const bottom = b.top + b.height / 2 - listRect.top - GAP;
            if (bottom <= top) continue;

            const connector = document.createElement('span');
            connector.className = 'agenda__connector';
            connector.style.top = `${top}px`;
            connector.style.height = `${bottom - top}px`;
            connector.style.left = `${a.left + a.width / 2 - listRect.left}px`;
            list.appendChild(connector);
        }
    };

    render();
    window.addEventListener('resize', render);
    if (document.fonts) {
        document.fonts.ready.then(render);
    }

    // Markers can still be mid scroll-reveal transform when we first measure them,
    // so re-measure once that settles to avoid a stale/misaligned connector line.
    const section = list.closest('section');
    if (section) {
        section.addEventListener('transitionend', render);
    }
});
